import React, { useEffect, useLayoutEffect, useState } from "react";
import { Card, Col, Divider, Row, Statistic, Table, Switch, Button, Tag, Tooltip, Input, message, Modal, DatePicker, Select, Descriptions, Flex } from "antd";
import { makeStyles } from "@mui/styles";
import { CheckCircleFilled, CheckOutlined, CloseOutlined, DeleteFilled, EditOutlined, InfoCircleOutlined, PlusOutlined } from "@ant-design/icons";
import Message from "../../Components/common/Message";
import AuthService from "../../Components/auth/AuthService";
import moment from "moment";
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import { Pagination } from "@mui/material";
import { DATE_FORMAT, DEFAULT_DATE_FORMAT, InventoryStatuses, issuePriorities } from "../../Components/common/constants";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { Autocomplete, Box, Grid, IconButton, TextField, Typography } from "@mui/material";
import { extractOriginalFileName, getNewFileName } from "../../Components/common/CommonFun";
import DeleteIcon from "@mui/icons-material/Delete";
import { domain, env, tms_uploads_bucket, tms_uploads_cdn } from "../../Components/config";
import qs from 'query-string';
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button as UploadButton } from "@mui/material";
import TextEditor from "../../Components/TextEditor/TextEditor";
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
const Auth = new AuthService();

const useStyles = makeStyles((theme) => ({
  dataSheet: {
    padding: "5px",

  },
}));

const IssueList = () => {
  const classes = useStyles();
  const { Option } = Select
  var layoutDispatch = useLoadingDispatch();
  const navigate = useNavigate();
  const userName = localStorage.getItem("logged_in_user_name");

  const [loadMessage, setLoadMessage] = useState("");
  const [type, setType] = useState("");
  const [allIssues, setAllIssues] = useState([]);
  const [page, setPage] = React.useState(1);
  const [pageChange, setPageChange] = React.useState(false);
  const [limit] = React.useState(50);
  const [totalPages, setTotalPages] = React.useState(0);
  const [totalCount, setTotalCount] = React.useState(null);

  const [users, setUsers] = useState([]);
  const [vehicles, setVehicles] = useState([]);


  const currentDate = new Date();
  const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const lastDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
  const lastDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
  const [startDate, setStartDate] = useState(firstDayOfMonth);
  const [endDate, setEndDate] = useState(lastDayOfMonth);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedText, setSelectedText] = useState("");

  const [closeModalVisible, setCloseModalVisible] = useState(false);
  const [closeIssueData, setCloseIssueData] = useState({
    date: null,
    notes: "",
    files: [],
  });

  console.log("closeIssueData", closeIssueData);
  const handleCloseIssue = async () => {
    if (!closeIssueData.date) {
      message.error('Select completion date to continue')
      return;
    }
    showLoading(layoutDispatch);
    const dataToSend = {
      id: closeIssueData.id,
      issue_completion_date: moment(closeIssueData.date).format("YYYY-MM-DD"),
      notes: closeIssueData.notes,
      files: closeIssueData.files,
    }
    const assignee = users.find((u) => u.id === closeIssueData.assigned_to);
    const emailPayload = {
      type: 3,
      assignee: assignee,
      priority: closeIssueData.priority == 1 ? "High" : closeIssueData.priority == 2 ? "Medium" : "Low",
      title: closeIssueData?.title,
      reported_by: userName,
      due_date: closeIssueData?.issue_due_date,
      completion_date: closeIssueData.date,
      issueID: closeIssueData?.id
    }
    try {
      const res = await Auth.fetch(`/issue/resolve-issue`, {
        method: "POST",
        body: JSON.stringify(dataToSend),
      });
      if (res?.ack) {
        const uploadPromises = []

        if (closeIssueData?.newFiles?.length > 0) {
          closeIssueData?.newFiles?.forEach((f) => {
            uploadPromises.push(
              getUploadUrl(f, closeIssueData.id)
                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                .catch(error => console.error("Error uploading file:", error))
            );
          });
        }
        await Promise.all(uploadPromises);
        if (env === "prod") {
          fetch("https://tmsemail.api-magnafoodservice.co.uk/api/email/issue", {
            method: "POST",
            headers: {
              Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAZ21haWwuY29tIiwidXNlcl9pZCI6MSwiaWF0IjoxNzI4NDE0NjIzLCJhdWQiOiJodHRwczovL3d3dy5tYWduYWZvb2RzZXJ2aWNlLmNvLnVrLyIsImlzcyI6Ik1hZ25hIEZvb2QgU2VydmljZSIsInN1YiI6Im5vb3JAZ21haWwuY29tIn0.fb--ERLcBgLhrec6Ed_rAR_uGiBWyFdLN-4fYjjdhjw411DODxyg058A7VVQuLAgD5A8OEa-9jOar0eOTqZk3WGnP8mhh_Tx0smCmiVNY73Odn0x0KZgVyx1yf4W6nEzAHJImmXwzbnPBTIVww7CG2a47GZ8M_XQxFJNhovOnIAEoIZdFz989QdyS_8UpTVIr1UV6nbpZ01ZNuHlU-ZBxJ9zPez1bD7Q9U8Gg59AeJsr3vp6XPDuWmW0C2G3Z3YO-5jT7e1S-lFNg7_8YTH5ju7RWlvdjOJ8lGIiQAVF4aRMXIJh3HHPYBdUWugj7Zb0ZF8F4rz8sR4zNgqEUXJtPQ",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(emailPayload),
          }).catch((err) => console.error("Error sending email:", err));
        } else if (env === "dev") {

          fetch("http://localhost:7420/api/email/issue", {
            method: "POST",
            headers: {
              Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAZ21haWwuY29tIiwidXNlcl9pZCI6MSwiaWF0IjoxNzI3ODgwNDE0LCJleHAiOjE3NTk0MTY0MTQsImF1ZCI6Imh0dHBzOi8vd3d3Lm1hZ25hZm9vZHNlcnZpY2UuY28udWsvIiwiaXNzIjoiTWFnbmEgRm9vZCBTZXJ2aWNlIiwic3ViIjoibm9vckBnbWFpbC5jb20ifQ.Bidb4jyOqnI4JdF9o0WpcEqiGQDpxv47KZ2mFyhFhLwj0LSui0ukFFH889J3tdVs3A-8ah-rk5026bfhEpneyUzkPl0IEE1iTBt4rdmXnUytXQRY38AsSiMv_v0S1gFL0JJtMh2Odzh3JpPbALaqEhCX0P2Kvhy9jNeczzWL8-rYw9b9WVgVN_mBd8AcdzgbzbeVOPd9hDL24im5QXwd6wIT9hme3e-lyBvW24bEp-ozxwaujVAZrtdh8BoSTTD2lyn0nKHc7iErGFjhFvtIw2pzvtnorNzfWJ2hB2BABQ0JOruxnxVks7NbNAMyBhchQhGV5af6ssDAZ4YaKUeNpw",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(emailPayload),
          }).catch((err) => console.error("Error sending email:", err));
        } else {
          fetch("http://34.197.161.10:7420/api/email/issue", {
            method: "POST",
            headers: {
              Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAbWFnbmFmb29kc2VydmljZS5jby51ayIsInVzZXJfaWQiOjEsImlhdCI6MTczNTU1OTM3NywiYXVkIjoiaHR0cHM6Ly93d3cubWFnbmFmb29kc2VydmljZS5jby51ay8iLCJpc3MiOiJNYWduYSBGb29kIFNlcnZpY2UiLCJzdWIiOiJub29yQG1hZ25hZm9vZHNlcnZpY2UuY28udWsifQ.ZC9_oBo2jQAz9EKCn19KD17WzMaVQPjuUUWhSBfDPPnaqb18j4cILaJIJUYgVprjjAGIzxUBt4Ln7do3br5Ps1nzkShjVrptne_eop_rxqcJCHnaIlra0UQnFsiTBJ8V_5GanQAQIVbuKwFlcpqJCb5adCeE5OipBANSURekGyMXSeYos4dVjrZu7g7DD8sxCWkePVW_LhlndbytgdkazRmOkHNmnq5x9bnO16fMAAPm1nMVxluC5bGJzJqCYhmnO-UlV6ZpAdCACS0ZW7tylwc2foEtkLz7jUE8X7hHUGCYfRO2N7gMcqKqBYgbf6DV5HEgsDFoEoGlxGjERqGjCQ",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(emailPayload),
          }).catch((err) => console.error("Error sending email:", err));
        }
        getAllIssues();
        message.success(res?.message);
      } else {
        message.error(res?.message);
      }
    } catch (err) {
      console.error(err);
      message.error(err?.message);
    } finally {
      hideLoading(layoutDispatch);
      setCloseModalVisible(false);
      setCloseIssueData({
        date: null,
        notes: "",
        files: [],
      });
    }
  };


  const getAllVehicles = async () => {
    showLoading(layoutDispatch);
    try {
      const response = await Auth.fetch(`/vehicle/vehicles`);
      if (response) {
        hideLoading(layoutDispatch);
        if (response?.ack) {
          setVehicles(response.vehicles);
        } else {
          setVehicles([])
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      hideLoading(layoutDispatch)
    }
  }

  const getAssignees = async () => {
    showLoading(layoutDispatch);
    try {
      const response = await Auth.fetch(`/issue/issues-assignees`);
      if (response) {
        hideLoading(layoutDispatch);
        if (response?.ack) {
          setUsers(response.issue_assignees);
        } else {
          setUsers([])
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      hideLoading(layoutDispatch)
    }
  }

  useLayoutEffect(() => {
    getAssignees();
    getAllVehicles();
  }, [])


  const handleChange = (event, value) => {
    setPage(value);
    setPageChange(true)
  };

  const getAllIssues = async (download) => {
    let search = {};
    if (page && pageChange) search.page = page;
    if (startDate) search.start_date = moment(startDate).format("YYYY-MM-DD");
    if (endDate) search.end_date = moment(endDate).format("YYYY-MM-DD");
    if (selectedVehicle) search.vehicle_id = selectedVehicle;
    if (selectedStatus) search.status = selectedStatus;
    if (selectedText) search.searchText = selectedText;

    if (download) search.download = 1;

    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch("/issue/issues", {
        method: "POST",
        body: JSON.stringify(search),
      });
      if (res?.ack) {
        if (download == 1) {
          window.open(res.file_url, "_blank", "noreferrer");
        } else {
          setAllIssues(res?.issues);
          setTotalPages(Math.ceil(res?.total_count / limit));
          setTotalCount(res.total_count);
          // setSelectedText("")
        }
      } else {
        setAllIssues([])
        message.error(res?.message)
      }
    } catch (err) {
      console.log(err);
      message.error(err?.message)
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  useEffect(() => {
    const timeOutId = setTimeout(() => getAllIssues(), 100);
    return () => clearTimeout(timeOutId);
  }, [
    page,
    startDate,
    endDate,
    selectedVehicle,
    selectedStatus,
    // selectedText
  ]);

  const OnTitleSearch = () => {
    setPageChange(false)
    setPage(1)
    getAllIssues()
  }

  const deleteIssue = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/issue/issue`, {
        method: "DELETE",
        body: JSON.stringify({ id: id })

      });
      if (res?.ack) {
        getAllIssues();
        message.success(res?.message);
      } else {
        message.error(res?.message);
      }
    } catch (err) {
      console.log(err);
      message.error(err?.message);
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  const issueColumns = [
    {
      title: 'Status',
      render: (_, record) => {
        const { completed_by, issue_due_date } = record;
        let statusText;
        let statusIcon;

        if (completed_by > 0) {
          statusText = 'Resolved';
          statusIcon = <CheckCircleFilled />;

        } else {
          const currentDate = new Date();
          const dueDate = new Date(issue_due_date);

          if (dueDate < currentDate) {
            statusText = 'Overdue';
            statusIcon = <CloseOutlined />;
          } else {
            statusText = 'Open';
            statusIcon = <CheckOutlined />;
          }
        }

        return (
          <Tag icon={statusIcon} color={statusText === 'Resolved' ? 'blue' : statusText === 'Overdue' ? 'red' : 'green'}>
            {statusText}
          </Tag>
        );
      },
    },

    {
      title: 'Code',
      dataIndex: 'issue_code',
      key: 'issue_code',
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Reported Date',
      render: (record) => {
        const localTime = dayjs.utc(record?.issue_date).local();
        return (
          <>
            <span>{localTime.format(`${DATE_FORMAT} HH:mm:ss`)}</span>
          </>
        )

      }
    },
    {
      title: 'Vehicle',
      render: ({ vehicle_id }) => {
        const object = vehicles?.find((obj) => obj.id === vehicle_id);
        return (
          <span >
            {`${object?.registration_number || ""}`}
          </span>
        );
      },
    },




    {
      align: "center",
      title: "Priority",
      render: ({ priority }) => {
        const object = issuePriorities.find((obj) => obj.id === priority);
        return (
          <Tag icon={object?.icon} color={object?.color}>
            {object?.title}
          </Tag>
        );
      },
    },

    {
      title: 'Reported To',
      render: ({ assigned_to }) => {
        const object = users?.find((obj) => obj.id === assigned_to);
        return (
          <span >
            {`${object?.first_name || ""} ${object?.last_name || ""}`}
          </span>
        );
      },
    },

    {
      title: 'Due Date',
      render: (record) => {
        const localTime = record.issue_due_date ? dayjs.utc(record?.issue_due_date).local() : '';

        return (
          <>
            <span>{localTime ? localTime.format(`${DATE_FORMAT} HH:mm:ss`) : ''}</span>
          </>
        )

      }
    },
    {
      title: 'Completion Date',
      render: (record) => {
        return (
          <>
            <span>{record.issue_completion_date ? dayjs(record.issue_completion_date).format(DATE_FORMAT) : ''}</span>
          </>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      align: 'right',
      render: (text, record) => (
        <Flex justify="end">
          {!record.completed_by > 0 && (
            <CheckCircleFilled
              style={{
                fontSize: "25px",
                cursor: "pointer",
                marginRight: "5px",
                color: "green",
              }}
              onClick={() => {
                setCloseIssueData({
                  ...record,
                  id: record.id,
                  date: new Date(),
                  notes: record.notes || "",
                  files: record.files ? JSON.parse(record.files) : [],
                  newFiles: [],
                });
                setCloseModalVisible(true);
              }}
            />
          )}
          {
            record.status == 1 && (
              <EditOutlined
                style={{
                  fontSize: "25px",
                  cursor: "pointer",
                  marginRight: "5px",
                  color: "#006cb8",
                }} onClick={() => navigate(`/workshop_issues/${record.id}`)} />
            )
          }


          {
            !record.completed_by > 0 && (
              <DeleteFilled style={
                {
                  fontSize: "25px",
                  cursor: "pointer",
                  color: "#cd1437",
                }} onClick={() => {
                  Modal.confirm({
                    title: 'Delete Issue',
                    centered: true,
                    content: `Are you sure you want to delete this issue?`,
                    onOk: () => deleteIssue(record.id),
                    okText: 'Delete',
                    cancelText: 'Cancel',
                    width: 600,
                    okButtonProps: { size: "large" },
                    cancelButtonProps: { size: "large" },
                  });
                }}
              />
            )
          }

        </Flex>
      )
    },
  ];

  useEffect(() => {
    message.config({
      top: window.innerHeight - 100,
      duration: 3,
    });
  }, []);
  console.log('closeIssueData', closeIssueData);

  const handleDeleteFile = (fileName) => {
    setCloseIssueData((prevData) => ({
      ...prevData,
      newFiles: prevData?.newFiles?.filter((file) => file.name !== fileName),
      files: prevData?.files?.filter((item) => item !== fileName)
    }));
  };

  const handleDeleteCurrentFile = (itemToDelete) => {
    setCloseIssueData((prevData) => ({
      ...prevData,
      files: prevData?.files?.filter((item) => item !== itemToDelete)
    }));
  };

  const handleSubmitImage = (e) => {
    e.preventDefault();
    let acceptedFiles = e.target.files;

    for (let file of acceptedFiles) {
      const randomString = Math.random().toString(36).substring(2, 10);
      const newFileName = getNewFileName(file.name)
      setCloseIssueData((prevData) => ({
        ...prevData,
        newFiles: [
          ...prevData.newFiles,
          {
            name: newFileName,
            display_name: file.name,
            file: file,
            ContentType: file.type,
          },
        ],
        files: [...prevData.files, newFileName],
      }));

    }
  };

  const getUploadUrl = async (file, recordID) => {
    const params = {
      bucket: tms_uploads_bucket,
      ContentType: file.file.type,
      Key: env + "/issues/" + recordID + "/" + file.name,
    };
    const response = await fetch(
      `${domain}/generate-put-url?${qs.stringify(params)}`,
      {
        headers: {
          "Content-Type": params.ContentType,
        },
      }
    );
    return response.json();
  };

  const uploadFileToS3 = async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl.putURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": contentType,
      },
    });
    if (response.status !== 200) {
      console.log('response', response);
      message.error("File upload failed.")
      throw new Error("File upload failed.");
    }
  };


  const updateFilters = (newValues) => {
    const existingFiltersString = localStorage.getItem('IssuesFilters');
    const existingFilters = existingFiltersString ? JSON.parse(existingFiltersString) : {};

    Object.assign(existingFilters, newValues);

    existingFilters.timestamp = new Date().getTime();

    const updatedFiltersString = JSON.stringify(existingFilters);

    localStorage.setItem('IssuesFilters', updatedFiltersString);
  };

  const getFiltersOrDefault = () => {
    const existingFiltersString = localStorage.getItem('IssuesFilters');
    const existingFilters = existingFiltersString ? JSON.parse(existingFiltersString) : {};
    const currentTime = new Date().getTime();
    const expirationTime = 30 * 60 * 1000;


    if (existingFilters.timestamp && currentTime - existingFilters.timestamp < expirationTime) {
      if (!existingFilters.vehicle) {
        existingFilters.vehicle = null;
      }

      if (!existingFilters.status) {
        existingFilters.status = null;
      }

      return existingFilters;
    } else {
      localStorage.removeItem('IssuesFilters');
      return {};
    }
  };

  useEffect(() => {
    const initialState = getFiltersOrDefault();
    setSelectedVehicle(initialState?.vehicle);
    setSelectedStatus(initialState?.status);
    if (!initialState?.startDate) {
      const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      setStartDate(firstDayOfMonth);
      initialState.startDate = firstDayOfMonth

    } else {
      setStartDate(initialState.startDate);
    }

    if (!initialState?.endDate) {
      const lastDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
      setEndDate(lastDayOfMonth);
      initialState.endDate = lastDateOfMonth

    } else {
      setEndDate(initialState.endDate);
    }
    initialState.timestamp = new Date().getTime();
    updateFilters(initialState)

  }, []);


  return (
    <div className={classes.dataSheet}>
      <Flex justify="space-between" align="center"  >
        <h2 style={{ margin: 0 }}>Issue List</h2>
        <Button onClick={() => navigate('/workshop_issues/new')} type="primary" icon={<PlusOutlined />}>Add Issue</Button>
      </Flex>

      <Grid container spacing={2}>
        {/* Start Date */}
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <label htmlFor="startDate">Start Due Date</label>
          <DatePicker
            format={DATE_FORMAT}
            style={{ width: '100%' }}
            size="large"
            value={startDate ? dayjs(startDate) : null}
            onChange={(date) => {
              const nativeDate = date ? date.toDate() : null;
              setStartDate(nativeDate);
              setPageChange(false)
              updateFilters({ startDate: nativeDate ? dayjs(nativeDate).format(DEFAULT_DATE_FORMAT) : null })
              setPage(1)
            }}
            placeholder="Select Date"
            allowClear={false}

          />
        </Grid>

        {/* End Date */}
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <label htmlFor="endDate">End Due Date</label>
          <DatePicker
            format={DATE_FORMAT}
            style={{ width: '100%' }}
            size="large"
            value={endDate ? dayjs(endDate) : null}
            onChange={(date) => {
              const nativeDate = date ? date.toDate() : null;
              setEndDate(nativeDate);
              setPageChange(false)
              setPage(1)
              updateFilters({ endDate: nativeDate ? dayjs(nativeDate).format(DEFAULT_DATE_FORMAT) : null })
            }}
            placeholder="Select Date"
            allowClear={false}

          />
        </Grid>

        {/* Vehicle */}
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <label htmlFor="vehicle">Vehicles</label>
          <Select
            style={{
              width: "100%",
            }}
            showSearch
            size="large"
            value={selectedVehicle}
            placeholder="Please Select"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
            allowClear
            onChange={(value) => {
              setSelectedVehicle(value)
              setPageChange(false)
              setPage(1)
              updateFilters({ vehicle: value })

            }}
          >
            {vehicles.map((item) => (
              <Option key={item.id} value={item.id}>
                {item?.registration_number}
              </Option>
            ))}
          </Select>
        </Grid>

        {/* Status */}
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <label htmlFor="status">Status</label>
          <Select
            style={{
              width: "100%",
            }}
            showSearch
            allowClear
            size="large"
            value={selectedStatus}
            placeholder="Status"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
            onChange={(value) => {
              setSelectedStatus(value)
              setPageChange(false)
              setPage(1)
              updateFilters({ status: value })
            }}
          >
            {InventoryStatuses.map((item) => (
              <Option key={item.id} value={item.id}>
                {item?.title}
              </Option>
            ))}
          </Select>
        </Grid>

        {/* Search Input + Button */}
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <div style={{ display: "flex", gap: "8px", marginTop: "21px" }}>
            <Input
              placeholder="Search By Title"
              value={selectedText}
              onChange={(e) => {
                setSelectedText(e.target.value);
              }}
              size="large"
            />
            <Button style={{ marginLeft: 5 }} type="primary" size="large" onClick={OnTitleSearch} >Search</Button>
          </div>
        </Grid>
      </Grid>
      <Table
        columns={issueColumns}
        style={{ marginTop: '10px' }}
        scroll={{ x: 'max-content' }}
        pagination={false}
        dataSource={allIssues?.filter((item) => item.status == 1)}
        footer={() => {
          const startRecord = (page - 1) * limit + 1;
          const endRecord = Math.min(page * limit, allIssues.length ? totalCount : 0);
          return `Showing ${startRecord}-${endRecord} of ${allIssues.length ? totalCount : "0"} Records`;
        }}
      />

      <div style={{ float: "right", margin: "10px" }}>
        <Pagination
          page={page}
          count={totalPages}
          variant="outlined"
          color="primary"
          onChange={handleChange}
        />
      </div>
      <Message type={type} msg={loadMessage} />
      <Modal
        title="Close Issue"
        open={closeModalVisible}
        onOk={handleCloseIssue}
        onCancel={() => setCloseModalVisible(false)}
        okText="Close Issue"
        cancelText="Cancel"
      >
        <Divider />

        {
          closeIssueData?.issue_date ? (
            <Descriptions style={{ marginBottom: "1px" }} bordered size={"small"}>
              <Descriptions.Item
                label={`Date`}
                labelStyle={{ width: "200px" }}
              >
                <span>{dayjs(closeIssueData?.issue_date).format(`${DATE_FORMAT} HH:mm:ss`)} </span><br />

              </Descriptions.Item>
            </Descriptions>
          ) : null
        }
        {
          closeIssueData?.title ? (
            <Descriptions style={{ marginBottom: "1px" }} bordered size={"small"}>
              <Descriptions.Item
                label={`Title`}
                labelStyle={{ width: "200px" }}
              >
                <span>{closeIssueData?.title} </span><br />

              </Descriptions.Item>
            </Descriptions>
          ) : null
        }

        <div style={{ marginBottom: "10px" }}>
          <label>Completion Date</label>
          <DatePicker
            format={DATE_FORMAT}
            style={{ width: "100%" }}
            size="large"
            value={closeIssueData.date ? dayjs(closeIssueData.date) : null}
            onChange={(date) => {
              const nativeDate = date ? date.toDate() : null;
              setCloseIssueData((prevData) => ({ ...prevData, date: nativeDate }));
            }
            }
          />
        </div>
        <div style={{ marginBottom: "10px" }}>
          <label>Notes</label>
          {/* <Input.TextArea
                  rows={4}
                  value={closeIssueData.notes}
                  onChange={(e) => setCloseIssueData({ ...closeIssueData, notes: e.target.value })}
                /> */}
          <TextEditor value={closeIssueData.notes} onChange={(value) => setCloseIssueData((prevData) => ({ ...prevData, notes: value }))} />
        </div>

        <div>
          <UploadButton
            component="label"
            variant="contained"
            sx={{ marginTop: "10px" }}
            startIcon={<CloudUploadIcon />}
          >
            Add files
            <input
              type="file"
              hidden
              multiple
              capture
              onChange={(e) => {
                const myfiles = e.target.files;

                if (myfiles.length > 10) {
                  message.error("A maximum of 10 images can be uploaded at a time.");
                  e.target.value = "";
                } else {
                  handleSubmitImage(e);
                }
              }}
            />
          </UploadButton>
        </div>

        {closeIssueData?.files?.length > 0 && <h4>Old Files:</h4>}
        <ul>
          {closeIssueData?.files?.length > 0 &&
            closeIssueData?.files
              .filter(
                (item) =>
                  !closeIssueData?.newFiles?.some((file) => file.name === item)
              )
              .map((item) => {
                const encodedFileName = item.replace(/\+/g, '%2B');
                return (
                  <li>
                    <IconButton
                      aria-label="delete"
                      color="primary"
                      onClick={() => handleDeleteCurrentFile(item)}
                    >
                      <DeleteIcon />
                    </IconButton>

                    <a
                      href={`${tms_uploads_cdn}/${env}/issues/${closeIssueData?.id}/${encodedFileName}`}
                      target="_blank"
                    >
                      {extractOriginalFileName(encodedFileName)}
                    </a>
                  </li>
                );
              })}
        </ul>
        <Divider />
        {closeIssueData?.newFiles?.length > 0 && <h4>New Files:</h4>}
        <ul>
          {closeIssueData?.newFiles?.length > 0 &&
            closeIssueData?.newFiles?.map((newFiles) => {
              const encodedFileName = newFiles?.name?.replace(/\+/g, '%2B');
              return (
                <li>
                  {" "}
                  <IconButton
                    aria-label="delete"
                    color="primary"
                    onClick={() => handleDeleteFile(newFiles.name)}
                  >
                    <DeleteIcon />
                  </IconButton>
                  {extractOriginalFileName(encodedFileName)}
                </li>
              );
            })}
        </ul>

      </Modal>
    </div>
  );
};

export default IssueList;
